'use client';

import { ReactNode } from 'react';
import { useAuth0 } from '@/contexts/Auth0Context';

// Legacy compatibility wrapper - redirects to Auth0
interface Session {
  user?: {
    name?: string | null;
    email?: string | null;
    image?: string | null;
  };
  expires: string;
}

interface SessionContextType {
  data: Session | null;
  status: 'loading' | 'authenticated' | 'unauthenticated';
  update: (data?: any) => Promise<Session | null>;
}

export function useSession(): SessionContextType {
  const { session, isLoading, isAuthenticated } = useAuth0();
  
  const data: Session | null = session ? {
    user: {
      name: session.user.name,
      email: session.user.email,
      image: session.user.picture,
    },
    expires: session.expiresAt ? new Date(session.expiresAt * 1000).toISOString() : new Date(Date.now() + 24 * 60 * 60 * 1000).toISOString(),
  } : null;

  return {
    data,
    status: isLoading ? 'loading' : isAuthenticated ? 'authenticated' : 'unauthenticated',
    update: async () => data,
  };
}

interface SessionProviderProps {
  children: ReactNode;
  session?: Session | null;
}

export function SessionProvider({ children }: SessionProviderProps) {
  return <>{children}</>;
}